<div #fileDiv>
<file-pond #myPond
    [options]="pondOptions"
    (oninit)="pondHandleInit()"
    (onaddfile)="pondHandleAddFile($event)"
    (onprocessfile) = "pondHandleUploadFile($event)"
    >
</file-pond>
</div>
